// extracted by css-extract-rspack-plugin
export default {"container":"container-UIkCZ6"};